/**
 * Parse multilingual JSON string
 */
export function parseMultilingualData<T = any>(data: string | null | undefined): T | null {
  if (!data) return null;
  
  try {
    return JSON.parse(data) as T;
  } catch (error) {
    console.error('Failed to parse multilingual data:', error);
    return null;
  }
}

/**
 * Stringify multilingual data
 */
export function stringifyMultilingualData<T = any>(data: T): string {
  return JSON.stringify(data);
}

/**
 * Get value for a specific language from multilingual object
 */
export function getMultilingualValue(
  data: Record<string, string> | null | undefined,
  language: string,
  fallbackLanguage = 'en'
): string {
  if (!data) return '';
  
  return data[language] || data[fallbackLanguage] || Object.values(data)[0] || '';
}